import React from "react";

/**
 * StageWords — the scrims and the lower third (Plan G). The title shows for
 * the first seconds of a scene and fades; the caption (on_screen_text only)
 * stays. For a people beat the relationship is the eyebrow and the name is
 * the title. Pure presentation.
 */
export default function StageWords({ title, titleVisible, eyebrow, caption, compact = true, liftForControls = false }) {
  return (
    <>
      <div style={w.scrimTop} aria-hidden="true" />
      <div style={w.scrimBottom} aria-hidden="true" />
      <div style={{ ...w.lower, ...(compact ? {} : w.lowerWide), bottom: liftForControls ? (compact ? 128 : 112) : (compact ? 72 : 48) }}>
        {eyebrow && <div style={w.eyebrow}>{eyebrow}</div>}
        {title && (
          <div style={{ ...w.title, ...(compact ? {} : w.titleWide), opacity: titleVisible ? 1 : 0, transition: eyebrow ? "none" : "opacity 600ms ease" }} aria-hidden={!titleVisible}>
            {title}
          </div>
        )}
        {caption && <div style={{ ...w.caption, ...(compact ? {} : w.captionWide) }}>{caption}</div>}
      </div>
    </>
  );
}

const w = {
  scrimTop:    { position: "absolute", left: 0, right: 0, top: 0, height: 120, background: "var(--overlay-scrim-top)", pointerEvents: "none", zIndex: 2 },
  scrimBottom: { position: "absolute", left: 0, right: 0, bottom: 0, height: "42%", background: "var(--overlay-scrim-bottom)", pointerEvents: "none", zIndex: 2 },
  lower:       { position: "absolute", left: 20, right: 20, display: "flex", flexDirection: "column", gap: 8, zIndex: 3, pointerEvents: "none", transition: "bottom 220ms ease" },
  lowerWide:   { left: 48, right: 48 },
  eyebrow:     { fontSize: 13, letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--overlay-text-muted)" },
  title:       { fontFamily: "var(--font-serif)", fontSize: 30, lineHeight: 1.15, fontWeight: 500, color: "var(--overlay-text)", textShadow: "0 1px 2px rgba(0,0,0,0.25)" },
  titleWide:   { fontSize: 44, lineHeight: 1.1 },
  caption:     { fontSize: 17, lineHeight: 1.45, color: "var(--overlay-text-muted)", maxWidth: 340, textShadow: "0 1px 2px rgba(0,0,0,0.25)" },
  captionWide: { fontSize: 21, maxWidth: 640 },
};
